module.exports = __webpack_public_path__ + "img/_ms-dagger_.16555550.svg";